<template>
  <div class="mcf-window">
    <div class="mcf-home-header">
      <div class="mcf-home-header-left">
        <div class="mcf-home-header-left-menu">
          <i class="fa fa-grip"></i>
        </div>
        <div class="mcf-home-header-left-title">
          <label>{{ title }}</label>
        </div>
      </div>
      <div class="mcf-home-header-center">
        <div class="mcf-home-search">
          <div class="mcf-home-search-icon">
            <i class="fa fa-search"></i>
          </div>
          <div class="mcf-home-search-content">
            <input type="text" v-model="txtsearch" placeholder="Rechercher" v-on:keyup.enter="evt_search_enter">
          </div>
        </div>
      </div>
      <div class="mcf-home-header-right">
        <ul>
          <li @click="change_theme"><i class='fa fa-cog'></i></li>
          <li><i class='fa fa-user'></i></li>
        </ul>
      </div>
    </div>
    <div class="mcf-home">
      <div class="mcf-home-menu">
        <ul>
          <li @click="menu_select('home')"
            :class="{ 'mcf-home-menu-grey': true, 'mcf-home-menu-grey-selected': (menu == 'home') }">
            <i class='fa fa-home'></i>
            <label>Accueil</label>
          </li>
          <li @click="menu_select('customers')"
            :class="{ 'mcf-home-menu-green': true, 'mcf-home-menu-green-selected': (menu == 'customers') }">
            <i class='fa fa-users'></i>
            <label>Clients</label>
          </li>
          <li @click="menu_select('products')"
            :class="{ 'mcf-home-menu-red': true, 'mcf-home-menu-red-selected': (menu == 'products') }">
            <i class='fa fa-boxes-stacked'></i>
            <label>Produits</label>
          </li>
          <!-- <li @click="menu_select('events')"
            :class="{ 'mcf-home-menu-orange': true, 'mcf-home-menu-orange-selected': (menu == 'events') }">
            <i class='fa fa-file-lines'></i>
            <label>Billetterie</label>
          </li> -->
          <li @click="menu_select('sales')"
            :class="{ 'mcf-home-menu-orange': true, 'mcf-home-menu-orange-selected': (menu == 'sales') }">
            <i class='fa fa-file-lines'></i>
            <label>Devis</label>
          </li>
          <li @click="menu_select('invoices')"
            :class="{ 'mcf-home-menu-blue': true, 'mcf-home-menu-blue-selected': (menu == 'invoices') }">
            <i class='fa fa-file-invoice'></i>
            <label>Factures</label>
          </li>
        </ul>
      </div>
      <div class="mcf-home-page">
        <div v-if="menu == 'home'" class="mcf-home-page-content">
          <h1>Bonjour {{ account.firstname }}</h1>
          <h2>Documents récents</h2>
          <div class="mcf-home-table">
            <div class="mcf-home-table-content">
              <div class="mcf-home-table-content-body">
                <div v-for="d of list" :key="d.id" class="mcf-home-table-line-short">
                  <div class="mcf-home-table-cell mcf-home-selection">
                    <i :class="d.logo" :style="'color:' + d.color"></i>
                  </div>
                  <div @click="bt_doc_select(d.id, d.vapp)" class="mcf-home-table-cell">
                    <label :style="'font-weight:bold;color:' + d.color">{{ d.title }}</label>
                    <label>{{ d.description }}</label>
                  </div>
                  <div @click="bt_doc_select(d.id, d.vapp)" class="mcf-home-table-cell">
                    <label>{{ $filters.mdatetime(d.date_update, lang) }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="menu == 'customers'" class="mcf-home-page-content">
          <button @click="bt_customer_add" class="mcf-home-new-item-customer"><i class='fa fa-plus'></i><label>Nouveau
              client</label></button>
          <div class="mcf-home-table">
            <div class="mcf-home-table-header">
              <ul class="mcf-home-table-header-filters">
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_customers == 'all') }"><i
                    class='fa fa-list'></i><label>Tous</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_customers == 'newly') }"><i
                    class='fa fa-clock'></i><label>Récemment ouverts</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_customers == 'active') }"><i
                    class='fa fa-filter'></i><label>Actifs</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_customers == 'inactive') }"><i
                    class='fa fa-ban'></i><label>Bloqués</label></li>
              </ul>
            </div>
            <div class="mcf-home-table-content">
              <div class="mcf-home-table-content-header">
                <div class="mcf-home-table-content-header-title mcf-home-selection">
                  <i class="fa fa-circle-dot"></i>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Raison sociale</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Ville</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Téléphone</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Etat</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Modifié</label>
                </div>
              </div>
              <div class="mcf-home-table-content-body">
                <div v-for="cust of customers" :key="cust.id" class="mcf-home-table-line">
                  <div class="mcf-home-table-cell mcf-home-selection">
                    <i class="fa fa-circle-dot"></i>
                  </div>
                  <div @click="bt_customer_select(cust.id)" class="mcf-home-table-cell">
                    <label v-if="cust.company != ''">{{ cust.company }}</label>
                    <label v-if="cust.company == ''">Client manquant des informations</label>
                  </div>
                  <div @click="bt_customer_select(cust.id)" class="mcf-home-table-cell">
                    <label>{{ cust.city }}</label>
                  </div>
                  <div @click="bt_customer_select(cust.id)" class="mcf-home-table-cell">
                    <label>{{ cust.phone }}</label>
                  </div>
                  <div @click="bt_customer_select(cust.id)" class="mcf-home-table-cell">
                    <label v-if="cust.is_inactive == 1"><i class="fa fa-ban"></i> Bloqué</label>
                  </div>
                  <div @click="bt_customer_select(cust.id)" class="mcf-home-table-cell">
                    <label>{{ $filters.mdatetime(cust.date_update, lang) }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="menu == 'products'" class="mcf-home-page-content">
          <button @click="bt_product_add" class="mcf-home-new-item-product"><i class='fa fa-plus'></i><label>Nouveau
              produit</label></button>
          <div class="mcf-home-table">
            <div class="mcf-home-table-header">
              <ul class="mcf-home-table-header-filters">
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_products == 'all') }"><i
                    class='fa fa-list'></i><label>Tous</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_products == 'newly') }"><i
                    class='fa fa-clock'></i><label>Récemment ouverts</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_products == 'active') }"><i
                    class='fa fa-filter'></i><label>Rupture de stock Web</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_products == 'active') }"><i
                    class='fa fa-filter'></i><label>Rupture de stock Magasin</label></li>
              </ul>
            </div>
            <div class="mcf-home-table-content">
              <div class="mcf-home-table-content-header">
                <div class="mcf-home-table-content-header-title mcf-home-selection">
                  <i class="fa fa-circle-dot"></i>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Référence</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Description</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Prix de vente</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Qté en ligne</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Qté en magasin</label>
                </div>
              </div>
              <div class="mcf-home-table-content-body">
                <div v-for="prod of products" :key="prod.id" class="mcf-home-table-line">
                  <div class="mcf-home-table-cell mcf-home-selection">
                    <i class="fa fa-circle-dot"></i>
                  </div>
                  <div @click="bt_product_select(prod.id)" class="mcf-home-table-cell">
                    <label v-if="prod.reference != ''">{{ prod.reference }}</label>
                    <label v-if="prod.reference == ''">Produit manquant des informations</label>
                  </div>
                  <div @click="bt_product_select(prod.id)" class="mcf-home-table-cell"
                    style="word-break: break-all;width: 100%;white-space: nowrap;overflow: hidden;">
                    <label>{{ prod.label }}</label>
                  </div>
                  <div @click="bt_product_select(prod.id)" class="mcf-home-table-cell">
                    <label>{{ $filters.money(prod.selling_price, lang) }}</label>
                  </div>
                  <div @click="bt_product_select(prod.id)" class="mcf-home-table-cell">
                    <label>{{ $filters.mdatetime(prod.date_update, lang) }}</label>
                  </div>
                  <div @click="bt_product_select(prod.id)" class="mcf-home-table-cell">
                    <label>{{ $filters.mdatetime(prod.date_update, lang) }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="menu == 'sales'" class="mcf-home-page-content">
          <button @click="bt_sale_add" class="mcf-home-new-item-sale"><i class='fa fa-plus'></i><label>Nouveau devis de
              vente</label></button>
          <div class="mcf-home-table">
            <div class="mcf-home-table-header">
              <ul class="mcf-home-table-header-filters">
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_sales == 'all') }"
                  @click="menu_sales = 'all'"><i class='fa fa-list'></i><label>Tous</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_sales == 'running') }"
                  @click="menu_sales = 'running'"><i class='fa fa-filter'></i><label>En cours</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_sales == 'sold') }"
                  @click="menu_sales = 'sold'"><i class='fa fa-filter'></i><label>Terminés</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_sales == 'lost') }"
                  @click="menu_sales = 'lost'"><i class='fa fa-filter'></i><label>Sans suite</label></li>
              </ul>
            </div>
            <div class="mcf-home-table-content">
              <div class="mcf-home-table-content-header">
                <div class="mcf-home-table-content-header-title mcf-home-selection">
                  <i class="fa fa-circle-dot"></i>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Numéro</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Client</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Total TTC</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Etat</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Date</label>
                </div>
              </div>
              <div class="mcf-home-table-content-body">
                <div v-for="sal of sales_filtered" :key="sal.id" class="mcf-home-table-line">
                  <div class="mcf-home-table-cell mcf-home-selection">
                    <i class="fa fa-circle-dot"></i>
                  </div>
                  <div @click="bt_sale_select(sal.id)" class="mcf-home-table-cell">
                    <label>{{ sal.sale_number }}</label>
                  </div>
                  <div @click="bt_sale_select(sal.id)" class="mcf-home-table-cell">
                    <label>{{ sal.cust_billingcompany }}</label>
                  </div>
                  <div @click="bt_sale_select(sal.id)" class="mcf-home-table-cell">
                    <label>{{ $filters.money(sal.total_ttc, lang) }}</label>
                  </div>
                  <div @click="bt_sale_select(sal.id)" class="mcf-home-table-cell">
                    <label>{{ lg[sal.state] }}</label>
                  </div>
                  <div @click="bt_sale_select(sal.id)" class="mcf-home-table-cell">
                    <label>{{ $filters.mdatetime(sal.sale_date, lang) }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="menu == 'invoices'" class="mcf-home-page-content">
          <button @click="bt_invoice_add" class="mcf-home-new-item-invoice"><i class='fa fa-plus'></i><label>Nouvelle
              facture</label></button>
          <div class="mcf-home-table">
            <div class="mcf-home-table-header">
              <ul class="mcf-home-table-header-filters">
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_invoices == 'all') }"
                  @click="menu_invoices = 'all'"><i class='fa fa-list'></i><label>Tous</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_invoices == 'running') }"
                  @click="menu_invoices = 'running'"><i class='fa fa-filter'></i><label>En cours</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_invoices == 'sold') }"
                  @click="menu_invoices = 'sold'"><i class='fa fa-filter'></i><label>Soldées</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_invoices == 'draft') }"
                  @click="menu_invoices = 'draft'"><i class='fa fa-filter'></i><label>Brouillons</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_invoices == 'ca') }"><i class='fa fa-info'></i><label>{{ tot_invoices_ca_year_n1 }}</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_invoices == 'ca') }"><i class='fa fa-info'></i><label>{{ tot_invoices_ca_year }}</label></li>                
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_invoices == 'can2') }"
                  @click="menu_invoices = 'can2'"><i class='fa fa-info'></i><label>{{ tot_invoices_ca_n2 }}</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_invoices == 'can1') }"
                  @click="menu_invoices = 'can1'"><i class='fa fa-info'></i><label>{{ tot_invoices_ca_n1 }}</label></li>
                <li :class="{ 'mcf-home-table-header-filters-selected': (menu_invoices == 'ca') }"
                  @click="menu_invoices = 'ca'"><i class='fa fa-info'></i><label>{{ tot_invoices_ca }}</label></li>
              </ul>
            </div>
            <div class="mcf-home-table-content">
              <div class="mcf-home-table-content-header-doc">
                <div class="mcf-home-table-content-header-title mcf-home-selection">
                  <i class="fa fa-circle-dot"></i>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Numéro</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Client</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Total TTC</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Etat</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Date</label>
                </div>
                <div class="mcf-home-table-content-header-title">
                  <label>Activité</label>
                </div>
              </div>
              <div class="mcf-home-table-content-body">
                <div v-for="inv of invoices_filtered" :key="inv.id" class="mcf-home-table-line-doc">
                  <div class="mcf-home-table-cell mcf-home-selection">
                    <i class="fa fa-circle-dot"></i>
                  </div>
                  <div @click="bt_invoice_select(inv.id)" class="mcf-home-table-cell">
                    <label>{{ inv.invoice_number }}</label>
                  </div>
                  <div @click="bt_invoice_select(inv.id)" class="mcf-home-table-cell">
                    <label>{{ inv.cust_billingcompany }}</label>
                  </div>
                  <div @click="bt_invoice_select(inv.id)" class="mcf-home-table-cell">
                    <label>{{ $filters.money(inv.total_ttc, lang) }}</label>
                  </div>
                  <div @click="bt_invoice_select(inv.id)" class="mcf-home-table-cell">
                    <label>{{ lg[inv.state] }}</label>
                  </div>
                  <div @click="bt_invoice_select(inv.id)" class="mcf-home-table-cell">
                    <label>{{ $filters.mdatetime(inv.invoice_date, lang) }}</label>
                  </div>
                  <div @click="bt_invoice_select(inv.id)" class="mcf-home-table-cell">
                    <label>{{ inv.activity }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dialogbox v-if="dialog_show" :setting="dialog_setting"></dialogbox>
    <loadingbox v-if="loading"></loadingbox>
  </div>
</template>

<script>
import apiaccount from "../core/data/account";
import tools from "../core/data/tools";
import translation from "../core/data/lang";
import apihome from "../core/data/home";
import apicustomer from "../core/data/customer";
import apiproduct from "../core/data/product";
import apisale from "../core/data/sale";
import apiinvoice from "../core/data/invoice";
import dialogbox from "../core/controls/ui-dialogbox";
import loadingbox from "../core/controls/ui-loadingbox";
import { DateTime } from "luxon";

export default {
  components: {
    dialogbox, loadingbox
  },
  data() {
    return {
      loading: false,
      lang: 'fr-FR',
      dialog_show: false,
      dialog_setting: {},
      title: 'Macrofox',
      account: {},
      list: [],
      customers: [],
      products: [],
      sales: [],
      invoices: [],
      txtsearch:'',
      menu: 'home',
      menu_customers: 'all',
      menu_products: 'all',
      menu_sales: 'all',
      menu_invoices: 'all'
    }
  },
  computed: {
    lg: function () {
      return translation.get(this.lang);
    },
    invoices_filtered: function () {
      var list = [];
      switch (this.menu_invoices) {
        case 'all':
          list = this.invoices;
          break;
        case 'running':
          list = this.invoices.filter(x => x.state == 'INV_LBL_RUNNING' || x.state=='INV_LBL_DRAFT');
          break;
        case 'sold':
          list = this.invoices.filter(x => x.state == 'INV_LBL_SOLD');
          break;
        case 'draft':
          list = this.invoices.filter(x => x.state == 'INV_LBL_DRAFT');
          break;
        case 'can2':
          list = this.invoices.filter(x => x.invoice_date.startsWith(DateTime.now().minus({ months: 2 }).toFormat('yyyy-MM')));
          break;
        case 'can1':
          list = this.invoices.filter(x => x.invoice_date.startsWith(DateTime.now().minus({ months: 1 }).toFormat('yyyy-MM')));
          break;
        case 'ca':
          list = this.invoices.filter(x => x.invoice_date.startsWith(DateTime.now().toFormat('yyyy-MM')));
          break;
        case 'search':
          list = this.invoices.filter(x=>x.cust_billingcompany.toLowerCase().indexOf(this.txtsearch.toLowerCase())>-1);
          break;
      }
      return list;
    },
    sales_filtered: function () {
      var list = [];
      switch (this.menu_sales) {
        case 'all':
          list = this.sales;
          break;
        case 'running':
          list = this.sales.filter(x => x.state == 'SAL_LBL_RUNNING');
          break;
        case 'sold':
          list = this.sales.filter(x => x.state == 'SAL_LBL_SOLD');
          break;
        case 'draft':
          list = this.sales.filter(x => x.state == 'SAL_LBL_DRAFT');
          break;
      }
      return list;
    },
    tot_invoices_ca_year: function(){
      var nb = 0;
      var vdate = DateTime.now().toFormat('yyyy');
      var list = this.invoices.filter(x => x.invoice_date.startsWith(vdate));
      for (var l of list) {
        nb += l.total_ttc;
      }
      return DateTime.now().toFormat('yyyy', { locale: 'fr' }) + " - " + this.$filters.money(nb, this.lang);
    },
    tot_invoices_ca_year_n1: function(){
      var nb = 0;
      var vdate = DateTime.now().minus({years:1}).toFormat('yyyy');
      var list = this.invoices.filter(x => x.invoice_date.startsWith(vdate));
      for (var l of list) {
        nb += l.total_ttc;
      }
      return DateTime.now().minus({years:1}).toFormat('yyyy', { locale: 'fr' }) + " - " + this.$filters.money(nb, this.lang);
    },
    tot_invoices_ca_n2: function () {
      var nb = 0;
      var vdate = DateTime.now().minus({ months: 2 }).toFormat('yyyy-MM');
      var list = this.invoices.filter(x => x.invoice_date.startsWith(vdate));
      for (var l of list) {
        nb += l.total_ttc;
      }
      return DateTime.now().minus({ months: 2 }).toFormat('MMMM yyyy', { locale: 'fr' }) + " - " + this.$filters.money(nb, this.lang);
    },
    tot_invoices_ca_n1: function () {
      var nb = 0;
      var vdate = DateTime.now().minus({ months: 1 }).toFormat('yyyy-MM');
      var list = this.invoices.filter(x => x.invoice_date.startsWith(vdate));
      for (var l of list) {
        nb += l.total_ttc;
      }
      return DateTime.now().minus({ months: 1 }).toFormat('MMMM yyyy', { locale: 'fr' }) + " - " + this.$filters.money(nb, this.lang);
    },
    tot_invoices_ca: function () {
      var nb = 0;
      var vdate = DateTime.now().toFormat('yyyy-MM');
      var list = this.invoices.filter(x => x.invoice_date.startsWith(vdate));
      for (var l of list) {
        nb += l.total_ttc;
      }
      return DateTime.now().toFormat('MMMM yyyy', { locale: 'fr' }) + " - " + this.$filters.money(nb, this.lang);
    }
  },
  created: async function () {
    var tmain = this;
    tools.set_theme("blue");
    tools.set_title("Macrofox Applications");
    var pkg = await apiaccount.info();
    if (pkg.code == 0) {
      tmain.account = pkg.data;
      tools.set_background(tmain.account.theme);
      var pkglist = await apihome.list();
      if (pkglist.code == 0) {
        tmain.list = pkglist.data;
        var info = localStorage.getItem("menu");
        if (info != undefined) {
          tmain.menu_select(info);
        }
      }
    } else {
      tmain.$router.push({ path: '/' });
    }
  },
  methods: {
    change_theme: async function () {
      this.account.theme = (this.account.theme == 'light' ? 'dark' : 'light');
      var pkg = await apiaccount.update(this.account);
      if (pkg.code == 0) {
        tools.set_background(this.account.theme);
      }
    },
    evt_search_enter: async function(){
      this.menu_invoices = (this.txtsearch!='' ? 'search' : 'all');
    },
    bt_doc_select: async function (id, vapp) {
      var tmain = this;
      localStorage.setItem("id", id);
      switch (vapp) {
        case "customers":
          tmain.$router.push({ path: '/customer' });
          break;
        case "products":
          tmain.$router.push({ path: '/product' });
          break;
        case "sales":
          tmain.$router.push({ path: '/sale' });
          break;
        case "invoices":
          tmain.$router.push({ path: '/invoice' });
          break;
      }

    },
    menu_select: async function (item) {
      var tmain = this;
      tmain.menu = item;
      localStorage.setItem("menu", item);
      switch (item) {
        case "home":
          tmain.title = "Macrofox";
          if (tmain.account.theme == 'light') {
            document.documentElement.style.setProperty("--TITLE", "#034B7B");
          }
          break;
        case "create":
          tmain.title = "Macrofox";
          if (tmain.account.theme == 'light') {
            document.documentElement.style.setProperty("--TITLE", "#034B7B");
          }
          break;
        case "customers":
          tmain.title = "Clients";
          if (tmain.account.theme == 'light') {
            document.documentElement.style.setProperty("--TITLE", "#008B00");
          }
          var pkgcustomers = await apihome.list_customers();
          if (pkgcustomers.code == 0) {
            tmain.customers = pkgcustomers.data;
          }
          break;
        case "products":
          tmain.title = "Produits";
          if (tmain.account.theme == 'light') {
            document.documentElement.style.setProperty("--TITLE", "#9E0707");
          }
          var pkgproducts = await apihome.list_products();
          if (pkgproducts.code == 0) {
            tmain.products = pkgproducts.data;
          }
          break;
        case "sales":
          tmain.title = "Ventes";
          if (tmain.account.theme == 'light') {
            document.documentElement.style.setProperty("--TITLE", "#AB5500");
          }
          var pkgsales = await apihome.list_sales();
          if (pkgsales.code == 0) {
            tmain.sales = pkgsales.data;
          }
          this.menu_sales = "running";
          break;
        case "invoices":
          tmain.title = "Factures";
          if (tmain.account.theme == 'light') {
            document.documentElement.style.setProperty("--TITLE", "#034B7B");
          }
          var pkginvoices = await apihome.list_invoices();
          if (pkginvoices.code == 0) {
            tmain.invoices = pkginvoices.data;
          }
          this.menu_invoices = "running";
          break;
      }
    },
    bt_customer_add: async function () {
      var tmain = this;
      tmain.dialog_setting = {
        icon: 'fa fa-plus',
        title: 'Nouveau',
        message: 'Voulez-vous créer un client ?',
        buttons: [
          {
            label: 'Oui',
            fx: async function () {
              var pkg = await apicustomer.new();
              if (pkg.code == 0) {
                var id = pkg.data.id;
                localStorage.setItem("id", id);
                tmain.$router.push({ path: '/customer' });
              }
            }
          },
          {
            label: 'Non',
            fx: function () {
              tmain.dialog_show = false;
            }
          }
        ]
      };
      tmain.dialog_show = true;
    },
    bt_customer_select: async function (id) {
      var tmain = this;
      localStorage.setItem("id", id);
      // tmain.$store.commit('set_id_form',id);
      tmain.$router.push({ path: '/customer' });
    },
    bt_product_add: async function () {
      var tmain = this;
      tmain.dialog_setting = {
        icon: 'fa fa-plus',
        title: 'Nouveau',
        message: 'Voulez-vous créer un produit ?',
        buttons: [
          {
            label: 'Oui',
            fx: async function () {
              var pkg = await apiproduct.new();
              if (pkg.code == 0) {
                var id = pkg.data.id;
                localStorage.setItem("id", id);
                tmain.$router.push({ path: '/product' });
              }
            }
          },
          {
            label: 'Non',
            fx: function () {
              tmain.dialog_show = false;
            }
          }
        ]
      };
      tmain.dialog_show = true;
    },
    bt_product_select: async function (id) {
      var tmain = this;
      localStorage.setItem("id", id);
      tmain.$router.push({ path: '/product' });
    },
    bt_sale_add: async function () {
      var tmain = this;
      tmain.dialog_setting = {
        icon: 'fa fa-plus',
        title: 'Nouveau',
        message: 'Voulez-vous créer un devis de vente ?',
        buttons: [
          {
            label: 'Oui',
            fx: async function () {
              var pkg = await apisale.new('');
              if (pkg.code == 0) {
                var id = pkg.data.id;
                localStorage.setItem("id", id);
                tmain.$router.push({ path: '/sale' });
              }
            }
          },
          {
            label: 'Non',
            fx: function () {
              tmain.dialog_show = false;
            }
          }
        ]
      };
      tmain.dialog_show = true;
    },
    bt_sale_select: async function (id) {
      var tmain = this;
      localStorage.setItem("id", id);
      tmain.$router.push({ path: '/sale' });
    },
    bt_invoice_add: async function () {
      var tmain = this;
      tmain.dialog_setting = {
        icon: 'fa fa-plus',
        title: 'Nouveau',
        message: 'Voulez-vous créer une facture ?',
        buttons: [
          {
            label: 'Oui',
            fx: async function () {
              var pkg = await apiinvoice.new('');
              if (pkg.code == 0) {
                var id = pkg.data.id;
                localStorage.setItem("id", id);
                tmain.$router.push({ path: '/invoice' });
              }
            }
          },
          {
            label: 'Non',
            fx: function () {
              tmain.dialog_show = false;
            }
          }
        ]
      };
      tmain.dialog_show = true;
    },
    bt_invoice_select: async function (id) {
      var tmain = this;
      localStorage.setItem("id", id);
      tmain.$router.push({ path: '/invoice' });
    }
  }
}
</script>